import { render, staticRenderFns } from "./private-sales-kata.vue?vue&type=template&id=63bccf84&"
import script from "./private-sales-kata.vue?vue&type=script&lang=js&"
export * from "./private-sales-kata.vue?vue&type=script&lang=js&"
import style0 from "./private-sales-kata.vue?vue&type=style&index=0&id=63bccf84&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports